import apiClient from "./apiClient";

// Shapes returned by the attendance endpoints (all times ISO UTC):
//
// Session  { id (null = record from before sessions existed), attendanceId, date,
//            source: "WEB"|"MOBILE"|"MANUAL"|"BIOMETRIC", checkInTime, checkOutTime, hours,
//            status: "VALID"|"FOR_REVIEW"|"APPROVED"|"REJECTED", statusReason, remarks,
//            reviewedAt, reviewRemarks, editedAt, checkIn: Point, checkOut: Point }
// Point    { latitude, longitude, accuracy, distance, outsideBranch, mapUrl }
// Day      the old day fields (checkInTime, checkOutTime, workHours, status, isLate…)
//          plus `sessions: Session[]` on check-in / check-out.
export const attendanceService = {
  // { serverTime, timezone: "Asia/Manila", manilaDate, manilaTime }
  getServerTime: () => apiClient.get("/attendance/server-time"),

  // { date, serverTime, attendance: Day|null, sessions, openSessionId,
  //   canCheckIn, canCheckOut, lockedReason, todayOvertime,
  //   summary: { firstCheckIn, lastCheckOut (null while open), sessionCount, workedHours, overtimeHours, multipleCheckIns },
  //   rules: { canCheckInAnywhere, allowMultipleCheckIns, multipleCheckInsFrom } }
  getMyToday: () => apiClient.get("/attendance/me/today"),

  // { employeeId, source: "WEB", location: { latitude, longitude, accuracy }, note? (≤500) } -> Day
  checkIn: (data) => apiClient.post("/attendance/check-in", data),

  // { attendanceId, location, note? (≤500) } -> Day (closes the open session)
  checkOut: (data) => apiClient.post("/attendance/check-out", data),

  // days[]: Day fields + id, source, sessionCount, forReviewCount, hasLocation
  getMonthlySummary: ({ employeeId, year, month }) =>
    apiClient.get(
      `/attendance/employee/${employeeId}/summary/${year}/${month}`,
    ),

  // { attendanceId, date, employee, branch: { id, name, latitude, longitude, radius, mapUrl }|null,
  //   sessions: Session[] }
  getLocations: (attendanceId) =>
    apiClient.get(`/attendance/${attendanceId}/locations`),

  // { canCheckInAnywhere, allowMultipleCheckIns, multipleCheckInsFrom, locationConsent,
  //   locationConsentAt, needsLocationConsent,
  //   branch: { id, name, latitude, longitude, radius, hasLocation }|null }
  getMySettings: () => apiClient.get("/attendance/settings/me"),

  // { granted, platform: "WEB" } -> same shape as getMySettings
  saveLocationConsent: (granted) =>
    apiClient.post("/attendance/settings/me/location-consent", {
      granted,
      platform: "WEB",
    }),
};
